import { useApiClient } from '@startupquickstart/frontend';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

interface GenerateTranslationVoiceoversParams {
  attractionId: string;
  translationId: string;
  voiceoverType: 'both' | 'description' | 'long_description';
  voice: 'alloy' | 'echo' | 'fable' | 'onyx' | 'nova' | 'shimmer';
}

/**
 * Hook for generating translation voiceovers
 */
export function useGenerateTranslationVoiceovers() {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ attractionId, translationId, voiceoverType, voice }: GenerateTranslationVoiceoversParams) => {
      return apiClient.post(
        `/attractions/${attractionId}/translations/${translationId}/generate-voiceovers`,
        { voiceoverType, voice },
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['Translation'] });
      toast.success('Voiceovers generated successfully');
    },
    onError: (error: Error) => {
      toast.error(error?.message || 'Failed to generate voiceovers');
    },
  });
}
